// src/pages/Workflows/Editor/hooks/useWorkflowEditor.js
// Gestão de metadata do workflow: nome, visibilidade, save/load

import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export function useWorkflowEditor(id) {
  const navigate = useNavigate();
  const [nome, setNome] = useState('Novo Workflow');
  const [visibilidade, setVisibilidade] = useState('private');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const carregar = useCallback(async () => {
    if (!id) return null;
    try {
      setLoading(true);
      const response = await axios.get(`/api/workflows/${id}`);
      if (response.data.success) {
        const wf = response.data.data;
        setNome(wf.nome);
        setVisibilidade(wf.visibilidade);
        return wf.definicao || { nodes: [], edges: [] };
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao carregar workflow');
    } finally {
      setLoading(false);
    }
    return null;
  }, [id]);

  const guardar = useCallback(async (definicao) => {
    if (!nome.trim()) {
      setError('O nome do workflow é obrigatório');
      return null;
    }
    try {
      setSaving(true);
      setError('');
      const payload = { nome: nome.trim(), visibilidade, definicao };

      let response;
      if (id) {
        response = await axios.put(`/api/workflows/${id}`, payload);
      } else {
        response = await axios.post('/api/workflows', payload);
      }

      if (response.data.success) {
        const wf = response.data.data;
        if (!id) {
          // Redirecionar para URL de edição com o novo ID
          navigate(`/workflows/${wf.id}/editar`, { replace: true });
        }
        return wf;
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao guardar workflow');
    } finally {
      setSaving(false);
    }
    return null;
  }, [id, nome, visibilidade, navigate]);

  return {
    nome, setNome,
    visibilidade, setVisibilidade,
    loading, saving, error, setError,
    carregar, guardar,
  };
}
